module.exports = __webpack_public_path__ + "img/discount.722b9c8.svg";